import { string, struct } from 'io-ts/Decoder';

import { ParentId } from './ParentId';

/**
 * Composite DynamoDB key for a form record: `(parentId, sk)`. Carried on the
 * v2 source-pipeline backfill SQS payload so the populate handler can hit
 * `byKeys` (BatchGetItem) directly without a GSI lookup.
 */
export const ComplexId = struct({
	parentId: ParentId,
	sk: string,
});
